import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisioneLegaleEStrategica from "./sections/VisioneLegaleEStrategica";
import IlCicloDellaConsulenza from "./sections/IlCicloDellaConsulenza";
import Faq from "./sections/Faq";
import RealEstateCleaning from "./sections/RealEstateCleaning";
import CardGrid from "./sections/CardGrid";
import EccellenzaContrattuale from "./sections/EccellenzaContrattuale";
import Attorney from "./sections/Attorney";
import LogoSlider from "./sections/LogoSlider";
import PonentesDestacados from "./sections/PonentesDestacados";
import Careers from "./sections/Careers";
import ParolaAiNostriClienti from "./sections/ParolaAiNostriClienti";
import PianificaLaTuaTutela from "./sections/PianificaLaTuaTutela";
import ServicesTeaser from "./sections/ServicesTeaser";
import CustomerServices from "./sections/CustomerServices";
import Blog from "./sections/Blog";
import NewsBoard from "./sections/NewsBoard";
import ArchitecturalPrecision from "./sections/ArchitecturalPrecision";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisioneLegaleEStrategica />
      <IlCicloDellaConsulenza />
      <Faq />
      <RealEstateCleaning />
      <CardGrid />
      <EccellenzaContrattuale />
      <Attorney />
      <LogoSlider />
      <PonentesDestacados />
      <Careers />
      <ParolaAiNostriClienti />
      <PianificaLaTuaTutela />
      <ServicesTeaser />
      <CustomerServices />
      <Blog />
      <NewsBoard />
      <ArchitecturalPrecision />
      <Footer />
    </div>;
}